import { Box, Container, SimpleGrid, Image, Link } from "@chakra-ui/react";
import JurorSlider from "../JurorSlider/index";
import TitleSpoleto from "../Title";
import SubTitle from "../SubTitle";

const slidesMobile = [
  {
    id: 1,
    src: "assets/jurados/guilherme_lira.png",
    link: "https://www.instagram.com/liraguilherme/",
  },
  {
    id: 2,
    src: "assets/jurados/life_bit.png",
    link: "https://www.instagram.com/lifeisabit/",
  },
  {
    id: 3,
    src: "assets/jurados/gabriel_sa.png",
    link: "https://www.instagram.com/gabrielsa.art/",
  },
  {
    id: 4,
    src: "assets/jurados/hugo_alberto.png",
    link: "https://www.instagram.com/hugoalbertoo/",
  },
  {
    id: 5,
    src: "assets/jurados/luize_santiago.png",
    link: "https://www.instagram.com/_luartes_/",
  },
  {
    id: 6,
    src: "assets/jurados/daniel_kalleb.png",
    link: "https://www.instagram.com/kallebdaniel/",
  },
  {
    id: 7,
    src: "assets/jurados/luana_marrochi.png",
    link: "#jurados",
  },
];

const Jurors = () => {
  return (
    <Box id="jurados" bg="transparent" py={12}>
      <TitleSpoleto color="#FCF3DB">Jurados</TitleSpoleto>
      <SubTitle color="#FCF3DB">Veja quem são os jurados deste ano.</SubTitle>
      <Box d={["block", null, "none"]}>
        <JurorSlider slides={slidesMobile} />
      </Box>
      <Box d={["none", null, "block"]} mt={12}>
        <Container maxW="container.xl">
          <SimpleGrid columns={3} spacing="40px" w="100%">
            {slidesMobile.map((slide) => (
              <Link
                d="block"
                key={slide.id}
                textAlign="center"
                href={slide.link}
                // target="_blank"
              >
                <Image d="inline-block" alt="jurado" src={slide.src} />
              </Link>
            ))}
          </SimpleGrid>
        </Container>
      </Box>
    </Box>
  );
};

export default Jurors;
